module.exports = __webpack_public_path__ + "static/media/processCheck.4f6c32bf.png";